<template>
        <label class="base-radio" :class="{'base-radio--disabled': disabled}">
            <input type="radio" :disabled="disabled" class="base-radio__input" :checked="shouldBeChecked" @change="updateInput" :name="name">
            <div class="base-radio__fill-square base-radio__fill-square--active-input"></div>
            <span class="base-radio__sign" :class="signClass">
                <slot></slot>
            </span>
        </label>
</template>


<script>
  export default {
    model: {
      prop: 'modelValue',
      event: 'change'
    },
    props: {
      value: {
        type: String,
      },
      disabled: {
        type: Boolean,
      },
      modelValue: {
        default: ""
      },
      inputName:{
        default: ''
      },
      name: {
        default: ''
      },
      signClass: {
        default: ''
      },
      additionalInfo: {
        type: Object
      }
    },

    computed: {
      shouldBeChecked() {
        return this.modelValue == this.value    }
    },

    methods: {
      updateInput() {
        if (!this.disabled) {
          this.$emit('change', {name: this.inputName, value: this.value, ...this.additionalInfo})
        }
        
      }
    }
  }
</script>